/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import VisImageCaptureController from './VisImageCaptureController';

const API_METHODS = [
	// host applications can use these api's to turn on/off image-capture feature
	'activate',
	'deactivate',
	'isActivated',

	// image capture specific APIs
	'registerCaptureHandlers'
];

/**
 * Visualization image capture feature is used to manage the thumbnail
 * generation in widgets.
 **/
class VisImageCaptureFeature {

	/**
	 * Visualization Image Capture feature constructor
	 *
	 * @param {WidgetAPI} widgetApi - widget API
	 * @param {DashboardAPI} dashboardApi - dashboard API
	 * @param {VisImageCaptureController} [controller] - feature controller
	 */
	constructor(widgetApi, dashboardApi, controller) {
		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;

		this._activated = false;

		this.controller = controller || new VisImageCaptureController(this, widgetApi, dashboardApi);
	}

	/**
	 * Visualization Image Capture feature destructor
	 */
	destroy() {
		this.deactivate();
		this.controller.destroy();
		this.controller = null;
	}

	/**
	 * Get feature API
	 *
	 * @return {VisImageCaptureFeatureAPI} API
	 */
	getAPI() {
		let api = {};
		API_METHODS
			.forEach(method => api[method] = this[method].bind(this));
		return api;
	}

	/**
	 * Activate feature
	 *
	 * @param {Object} [options={}] - options
	 */
	activate(options = {}) {
		this._activated = true;
		this.controller.activate(options);
	}

	/**
	 * Deactivate feature
	 */
	deactivate() {
		this._activated = false;
		this.controller.deactivate();
	}

	/**
	 * Check whether the feature is activated
	 *
	 * @return {boolean} TRUE if activated and FALSE if not
	 */
	isActivated() {
		return this._activated;
	}

	/**
	 * Register a capture handlers handler
	 *
	 * @param {Function} success - callback to call on successful image capture
	 * @param {Function} error - callback to call on error image capture
	 */
	registerCaptureHandlers(success, error) {
		this.controller.registerCaptureHandlers(success, error);
	}
}

VisImageCaptureFeature.API_METHODS = API_METHODS;

export default VisImageCaptureFeature;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-image-capture/src/js/VisImageCaptureFeature.js